var CategoryMenu           = require("./CategoryMenu"),
    Dropdown               = require("app/ui/Dropdown"),
    DropdownCaptureSupport = require("app/ui/DropdownCaptureSupport"),
    IconButton             = require("app/ui/IconButton"),
    ModalDropdownSupport   = require("app/AppLayout/ModalDropdownSupport"),
    buttons                = require("app/theme/buttons"),
    frameThrottle          = require("enyo-perf/utils").frameThrottle,
    kind                   = require("enyo/kind");

require("./CategoryDropdown.less");
require("app/theme/IconButton--header.less");
require("app/theme/styles/popups/Popup--plain.less");

module.exports = kind(/** @lends  app.AppHeader.CategoryDropdown.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.CategoryDropdown",

    /**
     * @private
     */
    kind: Dropdown,

    /**
     * @private
     */
    mixins: [
        DropdownCaptureSupport,
        ModalDropdownSupport
    ],

    /**
     * @private
     */
    classes: "app-app-header-category-dropdown",

    /**
     * The kind that will remain visible at all times and toggles the
     * dropdown when tapped.
     *
     * @type  {enyo.Control}
     * @public
     */
    activatorKind: IconButton,

    /**
     * Options for the activator.
     *
     * @type  {Object=}
     * @public
     */
    activatorOptions: {
        theme:         buttons["app.AppHeader.CategoryDropdown.activator"],
        iconAlignment: "right"
    },

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        theme:           "plain",
        showCloseButton: false
    },

    /**
     * @private
     */
    components: [{
        name:    "categoryMenu",
        kind:    CategoryMenu,
        classes: "app-app-header-category-dropdown__category-menu"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);

            // Update content
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {},
            $activator  = this.$.activator;

        $activator.setAttribute("disabled", state.isLoadingCategories);
        $activator.set("caption", i18nService.getString("app.AppHeader.CategoryMenu.Activator.title"));
        $activator.set("tooltip", i18nService.getString("app.AppHeader.CategoryMenu.Activator.tooltip"));

        if (state.isLoadingCategories) {
            $activator.set("icon", $activator.loadingIcon);
            !$activator.hasClass("loading") && $activator.addClass("loading");
        }
        else {
            while ($activator.hasClass("loading")) {
                $activator.removeClass("loading");
            }
            $activator.set("icon", $activator.loadedIcon);
        }
        this.$.categoryMenu.set("state", state);
    },

    /**
     * @private
     */
    requestHideDropdown: function() {
        this.hideDropdown();
    }

});
